import { FunctionComponent, PropsWithChildren } from 'react';
import {
  appHeaderHeight,
  siderAreaId,
} from 'packages/at-shell/components/app-shell/app-layout-constants';
import { elementSizeAtomFam } from 'packages/lib/common-ui/state';
import { useRecoilValue } from 'recoil';

export interface LayoutOptions {
  hasSiderHeader?: boolean;
}

export const LayoutStyles: FunctionComponent<
  PropsWithChildren<LayoutOptions>
> = (props) => {
  const { hasSiderHeader = true } = props;
  const siderWidth = useRecoilValue(elementSizeAtomFam(siderAreaId));
  return (
    <style type="text/css">{`
.layout-container {
  max-height: 100vh;
  max-width: 100vw;
  height: 100vh;
  width: 100vw;
  background: #000;
  overflow: hidden;
}
.layout-header {
  width: ${
    hasSiderHeader ? `calc(100% - ${siderWidth?.width ?? 0}px)` : '100%'
  };
  min-width: 500px;
  padding: 0.25rem 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${appHeaderHeight};
  overflow: hidden;
  position: relative;
  z-index: 1;
}
      `}</style>
  );
};
